<template>
  <div class="test-view practice-session">
    <div class="create-new-test">
      <div class="text-center">
        <v-btn
          class="right-btn cust-btn"
          color="primary"
          @click="gotoPracticeReports()"
        >
          Previous Practice Sessions
        </v-btn>
      </div>
    </div>
    <v-card
      class="mx-auto normal-card instructions-hg chart-padding same-height-card"
    >
      <div class="practice-session-outer">
        <div class="practice-session-row">
          <div
            class="practice-session-col"
            :class="subject.id == subjectId ? 'selected' + subject.name : 'Noneselected-bg'"
            @click="subjectSelected(subject.id)"
            v-for="subject in subjects"
            :key="subject.id"
          >
            <div
              class="sub-img-background"
              :class="
                subject.id == subjectId ? 'Noneselected-bg' : subject.name + '-bg'
              "
            >
              <img
                :src="require('@/assets/img/' + subject.name + 'Logo.svg')"
                :alt="subject.name"
              />
            </div>
            <div class="sub-practice-name">{{ subject.name }}</div>
          </div>
        </div>
      </div>
      <div class="full-width">
        <div class="add-ch-arrow practice-session-drop-outer">
          <div class="practice-session-drop-down">
            <div class="field-data">
              <label>Choose a Chapter:</label>
              <v-select
                v-model="selectedChapterID"
                :items="chapters"
                label=""
                hide-details
                dense
                outlined
                class="required fix-350-width"
              ></v-select>
            </div>
          </div>

          <div class="practice-session-drop-down">
            <div class="field-data">
              <label>Choose Topic (Optional):</label>
              <multi-select
                id="selected-topics"
                allText=""
                :items="topics"
                label=""
                :onChange="topicSelected"
                widthcss="fix-350"
              >
              </multi-select>
            </div>
          </div>

          <div class="practice-session-drop-down">
            <div class="field-data">
              <label>Question Type:</label>
              <v-select
                v-model="selectedQuestionType"
                @change="onQuestionTypeSelect"
                :items="qTypes"
                label=""
                hide-details
                dense
                outlined
                class="required fix-350-width"
              ></v-select>
            </div>
          </div>

          <div class="practice-session-drop-down" v-if="isOnlineInstitute">
            <div class="field-data">
              <label>Select Target Exam(s) for PYQs:</label>
              <multi-select
                id="selected-exams"
                allText=""
                :items="availableExams"
                label=""
                :onChange="examSelected"
                widthcss="fix-350"
              >
              </multi-select>
            </div>
          </div>
          
          <div class="check-opction-css check-cust" v-if="!isOnlineInstitute">
            <v-checkbox
              v-model="onlyPrevYearQuestions"
              hide-details
            ></v-checkbox>
            Practice only Previous Years' Questions
          </div>

        </div>
      </div>
      <div class="Start-Pratice-Session">
        <div class="next-que-btn">
          <v-btn
            color="primary"
            :loading="loading"
            class="cust-btn right-align report_error_btn"
            @click=" requestCreateTest()"
            >Start Practice Session
          </v-btn>
        </div>
      </div>
    </v-card>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import constants from "@/utils/constants.js";
import moment from "moment";
import { showUpgradeModal } from "@/utils/upgradeUtils";

export default {
  name: "PracticeSession",
  mounted() {
    console.log('Mounted - Is Online Institute:', this.isOnlineInstitute, 'Institute ID:', this.user?.institute);
    this.checkSessionData();
    this.initializeAvailableExams();
    this.checkStudentUpgraded();
  },
  data() {
    return {
      chapterName: "",
      alertBoxData: {},
      phySel: false,
      chemSel: false,
      mathSel: false,
      bioSel: false,
      subjects: [],
      cComponent: "",
      onlyPrevYearQuestions: false,
      chapters: [],
      topics: [],
      selectedChapterID: [],
      selectedQuestionType: [],
      qTypes: [],
      practiceSessionID: null,
      sessionId: null,
      test_entity_id: null,
      ps_id: null,
      subjectId: null,
      topic_id: null,
      status: false,
      modalwidth: "500px",
      loading: false,
      selectedExams: [],
      availableExams: []
    };
  },
  computed: {
    ...mapGetters("healthStore", ["selectedChapter"]),
    ...mapState("userStore", ["user"]),
    isOnlineInstitute() {
      return this.user && this.user.institute === constants.ONLINE_INSTITUTE_ID;
    },
  },
  methods: {
    showUpgradeConfirmationModal() {
      showUpgradeModal(this);
    },
    ...mapActions({
      setSelectedSubjectData: "healthStore/setSelectedSubjectData",
      getRefData: "utilStore/getRefData",
      setSelectedChapter: "healthStore/setSelectedChapter",
      getChildren: "resultStore/getChildren",
      getSubjectBatchWise: "resultStore/getSubjectBatchWise",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      createTestForPracticeSession: "testStore/createTestForPracticeSession",
      updateTestForPracticeSession: "testStore/updateTestForPracticeSession",
    }),
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    subjectSelected(subjectId) {
      this.subjects.map((s) => {
        if (s.id == subjectId) {
          s.selected = true;
        } else {
          s.selected = false;
        }
      }); 
      this.subjectId = subjectId;
        this.scrollToBottom();
    },
    chapterSelected(chapterID) {
      let reqData = {
        level: 4,
        parent: chapterID,
      };
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      this.selectedChapterID = chapterID;
      this.topics = [];
      this.topic_id = this.selectedChapterID == crd.tabDetails[crd.selectedTab].chapter_id ? this.topic_id : [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.topics = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            c.checked = this.topic_id && this.topic_id.length && this.topic_id.includes(x.id) ? true :false;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    topicSelected(topicID) {
      this.topic_id = topicID;
      this.updateRouteDetails({
        type: "topic_id",
        data: { topic_id: topicID },
      });
    },
    examSelected(examIds) {
      this.selectedExams = examIds;
      this.updateRouteDetails({
        type: "selected_exams",
        data: { selected_exams: examIds },
      });
    },
    initializeAvailableExams() {
      if (this.isOnlineInstitute) {
        const selectedExamIds = this.selectedExams || [];
        this.availableExams = [
          { text: 'JEE MAIN', value: constants.TARGET_EXAMS.JEE_MAIN, checked: selectedExamIds.includes(constants.TARGET_EXAMS.JEE_MAIN) },
          { text: 'JEE ADVANCED', value: constants.TARGET_EXAMS.JEE_ADVANCED, checked: selectedExamIds.includes(constants.TARGET_EXAMS.JEE_ADVANCED) },
          { text: 'NEET', value: constants.TARGET_EXAMS.NEET, checked: selectedExamIds.includes(constants.TARGET_EXAMS.NEET) },
          { text: 'EAMCET', value: constants.TARGET_EXAMS.EAMCET, checked: selectedExamIds.includes(constants.TARGET_EXAMS.EAMCET) },
          { text: 'KCET', value: constants.TARGET_EXAMS.KCET, checked: selectedExamIds.includes(constants.TARGET_EXAMS.KCET) },
          { text: 'MHTCET', value: constants.TARGET_EXAMS.MHCET, checked: selectedExamIds.includes(constants.TARGET_EXAMS.MHCET) },
        ];
        // REWISE_VAS 3.3: exams follow the chosen subject — Mathematics never sits NEET, Biology
        // never sits JEE; Physics / Chemistry keep the full list. Selections that fall out are dropped.
        const drop = this.subjectId == constants.MATHEMATICS_SUBJECT_ID
          ? [constants.TARGET_EXAMS.NEET]
          : this.subjectId == constants.BIOLOGY_SUBJECT_ID
            ? [constants.TARGET_EXAMS.JEE_MAIN, constants.TARGET_EXAMS.JEE_ADVANCED]
            : [];
        if (drop.length) {
          this.availableExams = this.availableExams.filter(e => !drop.includes(e.value));
          const kept = selectedExamIds.filter(id => !drop.includes(id));
          if (kept.length !== selectedExamIds.length) {
            this.selectedExams = kept;
            this.updateRouteDetails({ type: "selected_exams", data: { selected_exams: kept } });
          }
        }
        console.log('Available exams initialized:', this.availableExams);
      }
    },
    getSubject() {
      let reqData = {
        student_id: this.user.id,
        batch_id: this.user.batch_id,
      };
      if (this.isParent) {
        reqData.student_id = this.studentId;
        reqData.batch_id = this.selectedStudent.batchId;
      }
      let me = this;
      this.getSubjectBatchWise(reqData)
        .then((response) => {
          this.subjects = response.map((s) => {
            return {
              name: s.title,
              id: s.id,
              selected: false,
            };
          });
          me.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
          me.$root.showLoader = false;
        });
    },
    gotoPracticeReports() {
      this.$router.push({
        name: "practice-report",
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err);
        }
      });
    },
    scrollToBottom() {
      let scrollElem = document.getElementsByClassName("full-width");
      scrollElem[0].scrollIntoView({behavior: "smooth"});
    },
    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"] };
      this.getRefData(reqData)
        .then((response) => {
          this.loading = false;
          this.qTypes = constants.QUESTION_TYPES_PS.filter(
            (xx) =>
              xx.id != 14 &&
              xx.id != 15 &&
              xx.id != 16 &&
              xx.id != 17 &&
              xx.id != 18 &&
              xx.id != 20 &&
              xx.id != 21
          ).map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.value;
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onQuestionTypeSelect(questionTypeId) {
      this.selectedQuestionType = questionTypeId;
    },
    onClose(data) {
      // Handle upgrade confirmation modal response
      if (data.openPaymentModal) {
        this.cComponent = 'components/student/UpgradeToGold/GstChargesPopUp';
        this.modalwidth = '500px';
        this.status = true;
        this.alertBoxData = data.paymentData;
        return;
      }
      
      this.status = data.status;
      if (data.redirectTo) {
        this.redirectTo(data.redirectTo);
      }
    },
    requestCreateTest() {
      if (this.validate(true) ) {
      let reqData = {
        test_name: constants.TEST_NAME_PRACTICE_SESSION, // from constansts.js
          chapter_id: this.selectedChapterID ? [this.selectedChapterID] : [],
          subject_id: this.subjectId,
          required_pyq: null,
          topic_id: this.topic_id,
          question_types: this.selectedQuestionType,
          test_sub_type: constants.TEST_SUB_TYPE_PRACTICE_SESSION, // from constansts.js
          test_type: constants.TEST_TYPE_PRACTICE_SESSION, // from constansts.js
        };
        this.loading = reqData.question_types ? true : false;
        if(this.user.institute === constants.ONLINE_INSTITUTE_ID){
          reqData.required_pyq = 1;
          reqData.target_exams = this.selectedExams;
        }else{
          reqData.required_pyq = this.onlyPrevYearQuestions ? 1 : 0;
        }
        this.createTestForPracticeSession(reqData)
          .then((response) => {
            this.removeSessionData();
            localStorage.setItem(
              "session_start",
              response.practice_session.start_time
            );
            this.loading = false;
            localStorage.setItem("previousPath", this.$route.path);
            this.$router.push({
              name: "practice-session-question-view",
              params: {
                practice_session_id: response.practice_session.id,
                subject_id: response.practice_session.subject_id,
                test_id: response.id,
                topicsSelected: this.topic_id && this.topic_id.length > 0 ? 1 : 0,
              },
            }).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('Navigation error:', err);
              }
            });
          })
          .catch((err) => {
            this.loading = false;
            this.$root.showLoader = false;
            if(err.data && err.data.errors && err.data.errors[0].code === "ERR0223"){
              this.showUpgradeConfirmationModal();
              return;
            }
            // Show toaster for other errors
            // if(err.data && err.data.errors && err.data.errors[0].message) {
            //   this.$toasted.error(err.data.errors[0].message);
            // }
          });
      }
    },
    checkStudentUpgraded() {
      
      const modules = JSON.parse(localStorage.getItem("modules")) || [];
      let hasBoostUpAccess;
      if(this.user.institute !== constants.ONLINE_INSTITUTE_ID){
        hasBoostUpAccess = modules.find(m => m.module_id === 10);
        if(hasBoostUpAccess){
          return false;
        }
      }


      // this.status = this.checkStudentUpgradedHelper(
      //   this.user.subscription_details
      // );
      
      // this.cComponent =
      //   "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
      // (this.modalwidth = "500px"), (this.alertBoxData = {});
       return false;
    },

    redirectTo(route) {
      this.$router.push({
        name: route,
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err);
        }
      });
    },
    validate(showErrorMsg) {
      let isValid = true;
      if (!this.subjectId) {
        if (showErrorMsg) {
          
          this.$toasted.error(
            "Please Select a Subject and a Chapter to Start Practice Session"
        );
        }
        isValid = false;
      }else if (!this.selectedChapterID ) {
        if (showErrorMsg) {
          this.$toasted.error(
              "Please Select a Chapter to Start Practice Session"
          );
          
        }
        isValid = false;
      }else if (this.selectedQuestionType && this.selectedQuestionType.length == 0) {
          this.$toasted.error(
            "Please select a Question Type"
        );
        isValid = false;
      }else if (this.isOnlineInstitute && (!this.selectedExams || this.selectedExams.length === 0)) {
        if (showErrorMsg) {
          this.$toasted.error(
            "Please select at least one Target Exam for PYQs"
          );
        }
        isValid = false;
      }
      return isValid;
    },
    defaultData(){
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.subjectId = crd.tabDetails[crd.selectedTab].subject_id; // load subject id from session
        this.selectedChapterID = crd.tabDetails[crd.selectedTab].chapter_id; // load chapter id in session
        this.topic_id = crd.tabDetails[crd.selectedTab].topic_id; // load topic id in session
        this.selectedQuestionType = crd.tabDetails[crd.selectedTab].question_types; // load topic id in session
        this.onlyPrevYearQuestions = crd.tabDetails[crd.selectedTab].required_pyq; // load topic id in session
        this.selectedExams = crd.tabDetails[crd.selectedTab].selected_exams || [];
      }
        if (this.compareEvent(constants.EVENT.CREATE_PRACTICE_SESSION)) {
            this.removeEvent()
            this.requestCreateTest();
        }

        this.getSubject();
        this.requestGetRefData();
        this.initializeAvailableExams();
        localStorage.removeItem("prevPath");
        localStorage.setItem('prevPath',this.$route.name);
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { subject_id: null, chapter_id: null,question_types:null,topic_id:null,required_pyq:false,is_create_practice_session:false,selected_exams:[]},
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd.tabDetails[crd.selectedTab]) {
        switch (details.type) {
          case "subject_id":
            crd.tabDetails[crd.selectedTab].subject_id = details.data.subject_id;
            break;
          case "chapter_id":
            crd.tabDetails[crd.selectedTab].chapter_id = details.data.chapter_id;
            break;
          case "question_types":
            crd.tabDetails[crd.selectedTab].question_types = details.data.question_types;
            break;
          case "topic_id":
            crd.tabDetails[crd.selectedTab].topic_id = details.data.topic_id;
            break;
          case "required_pyq":
            crd.tabDetails[crd.selectedTab].required_pyq = details.data.required_pyq;
            break;
          case "selected_exams":
            crd.tabDetails[crd.selectedTab].selected_exams = details.data.selected_exams;
            break;
          default:
            break;
        }
      }
      this.setRouteDetails(crd);
    },
    getDataTreeSubjectIdApi(subjectId){
      let reqData = {
        level: 3,
        parent: subjectId,
      };
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if(this.subjectId != crd.tabDetails[crd.selectedTab].subject_id){
        this.selectedChapterID = null;
        this.topic_id = [];
      }
        this.topics = [];
      this.chapters = [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          console.log('1st');
          this.isApiCall = false;
          this.$root.showLoader = false;
          this.chapters = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getDataTreeSubjectIdApi(subjectId){
      let reqData = {
        level: 3,
        parent: subjectId,
      };
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if(this.subjectId != crd.tabDetails[crd.selectedTab].subject_id){
        this.selectedChapterID = null;
        this.topic_id = [];
      }
        this.topics = [];
      this.chapters = [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          console.log('1st');
          this.isApiCall = false;
          this.$root.showLoader = false;
          this.chapters = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
  },
  watch: {
    selectedQuestionType(val) {
      if (val) {
        this.updateRouteDetails({
        type: "question_types",
        data: { question_types: this.selectedQuestionType },
      });
      }
    },
    selectedChapterID(val) {
      if (val) {
        this.updateRouteDetails({
        type: "chapter_id",
        data: { chapter_id: val },
        });
        this.chapterSelected(val)
      }
    },
    subjectId(val){
      if (val) {
          this.updateRouteDetails({
            type: "subject_id",
            data: { subject_id: val },
          });
          this.getDataTreeSubjectIdApi(val);
          this.initializeAvailableExams(); // REWISE_VAS 3.3: re-filter the exam list for the subject
      }
    },
    onlyPrevYearQuestions(val){

      this.updateRouteDetails({
          type: "required_pyq",
          data: { required_pyq: val },
        });
    },
    isOnlineInstitute: {
      immediate: true,
      handler(val) {
        console.log('isOnlineInstitute changed:', val);
        if (val) {
          this.initializeAvailableExams();
        }
      }
    }
  },
  destroyed(){
            this.removeEvent()

  }
};
</script>
